<template>
  <div class="start-screen">
    <div>
      <h1 class="start-screen__title">
        <span>메타 인지</span>
        <span>수학 테스트</span>
      </h1>

      <p class="start-screen__subtitle">
        당신의 수학 뇌는 어떤 유형일까요?
      </p>
    </div>

    <div class="start-screen__hero">
      <BrainMascotPlaceholder />
    </div>

    <button
      class="primary-button"
      type="button"
      @click="$emit('start')"
    >
      테스트 시작하기
    </button>
  </div>
</template>

<script setup lang="ts">
import BrainMascotPlaceholder from '@/components/BrainMascotPlaceholder.vue'

defineEmits<{ start: [] }>()
</script>

<style scoped>
.start-screen__hero {
  margin-bottom: 28px;
}
</style>